import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class RegistrationPaymentRoute extends Route {
  mainLayout = MainLayout;

  @service checkout;
  @service deviceManager;
  @service intl;
  @service('stripev3') stripe;
  @service router;
  @service pricingService;

  beforeModel() {
    return this.stripe.load();
  }

  async model() {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');

    let selectedProducts = await (async () => {
      try {
        return await this.checkout.fetchPricePlanSelectedTask.perform(organization.id);
      } catch {
        throw new Error('no price plan is selected');
      }
    })();

    let selectedPricePlan = selectedProducts.selected_products.find(
      ({ product_kind: kind }) => kind === 'core'
    );

    try {
      let [estimation, pricePlans] = await Promise.all([
        this.checkout.fetchPriceEstimateForCompanyCreationTask.perform({
          legalCountry: selectedProducts.legal_country,
          productId: selectedPricePlan.product_id,
          recurrence: selectedPricePlan.recurrence,
        }),
      ]);

      return {
        estimation,
        organization,
        registration,
        pricePlans,
        selectedProducts,
        selectedPricePlan,
      };
    } catch {
      // Trigger error page if the order is not found
      throw new Error('no order found');
    }
  }

  redirect() {
    if (this.modelFor('registration').isPaid) {
      return this.router.transitionTo('registration.almost-ready');
    }
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    let stripeCardElements = this.stripe.elements({
      locale: this.intl.primaryLocale,
    });

    // Prevent mobile devices from zooming on input focus
    let fontSize = this.deviceManager.isMobile ? '16px' : '14px';

    // Specific options for Stripe Element
    let stripeOptions = {
      hidePostalCode: true,
      style: {
        base: {
          color: '#414660',
          lineHeight: '24px',
          fontFamily: '"Segoe UI", "Roboto","Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize,
          '::placeholder': {
            color: '#9fa3b5',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      },
    };

    controller.setProperties({
      model,
      registration: this.modelFor('registration'),
      stripeOptions,
      stripeCardElements,
    });
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      controller.setProperties({
        userName: null,
        termsAndConditionsChecked: false,
        isComplete: false,
      });
    }
  }

  activate() {
    // this sets an event for 'localeChanged' on which intl service
    // emits whenever locale is updated through 'setLocale'
    this.intl.onLocaleChanged(this.refresh, this);
  }
}
